// src/App.js
import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./styles/index.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Experience = lazy(() => import("./pages/Experience"));
const ExpandedExperience = lazy(() => import("./pages/ExpandedExperience"));
const Projects = lazy(() => import("./pages/Projects"));
const DisplayProject = lazy(() => import("./pages/DisplayProject"));
const Contact = lazy(() => import("./pages/Contact"));
const Confirmation = lazy(() => import("./pages/Confirmation"));
const Error = lazy(() => import("./pages/Error"));
const LoadingPage = lazy(() => import("./pages/LoadingPage"));

function App() {
  return (
    // <div className="App">
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Suspense fallback={<LoadingPage />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/experience/:slug" element={<ExpandedExperience />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<DisplayProject />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact/confirmation" element={<Confirmation />} />
            <Route path="*" element={<Error />} />

            {/* For TESTING */}
            {/* <Route path="/error" element={<Error />} /> */}
            {/* <Route path="/loading" element={<LoadingPage />} /> */}
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
